<template>
  <div class="p-referrals g-page">
    <v-table
      :loading="pageLoading"
      :thead="[
        { value: 'Name', width: 40 },
        { value: 'Email', width: 60 }]"
      :tbody="results"
      :columns="['name', 'email']"
      noResultsMessage="No contacts were found."
      data-test="referrals-table" />
    <v-paginate
      :loading="results.length > $store.state.subaccounts.pagingLimit"
      storeAction="referrals/PAGINATE"
      :current="$store.getters['referrals/currentPage'] + 1"
      :last="$store.getters['referrals/totalPages']"
      :showUrl="false" />
  </div>
</template>

<script>
import { VPaginate, VTable } from '@signable/ui-kit/src/molecules';

export default {
  name: 'referrals',
  components: {
    VPaginate,
    VTable,
  },
  data() {
    return {
      // isSearching: false,
    };
  },
  created() {
    this.$store.dispatch('referrals/PAGINATE', { page: 1 }).then(() => {
      this.loading = false;
    });
  },
  computed: {
    results() {
      return this.$store.getters['referrals/pagedResults'];
    },
    pageLoading() {
      if (this.loading || (!this.isSearching && !this.results[0])) {
        return true;
      }

      return false;
    },
  },
};
</script>
